import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState, } from 'react';
import errorHandler from '../services/errorHandler';
import InitErrorMessage from './InitErrorMessage';
const ParallelContextualizedInitializer = ({ initializers, children, loader }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [initializedProps, setInitializedProps] = useState([]);
    const initializationResults = initializers.map((initializer) => {
        const hookResult = typeof initializer.hooks === 'function' ? initializer.hooks() : {};
        return useMemo(() => initializer.initialize(hookResult), Object.values(hookResult));
    });
    useEffect(() => {
        Promise.all(initializationResults)
            .then(props => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setInitializedProps(props);
            setLoaded(true);
        })
            .catch(error => {
            errorHandler.handleError(error);
            setError(error);
        });
    }, [...initializationResults]);
    if (error) {
        return (_jsx(InitErrorMessage, { message: 'Failed to initialize widget.', error: error }, void 0));
    }
    if (!loaded) {
        return loader ? _jsx(_Fragment, { children: loader }, void 0) : _jsx("div", { children: "..." }, void 0);
    }
    const renderTree = (index = 0) => {
        if (index === initializers.length) {
            return _jsx(_Fragment, { children: children }, void 0);
        }
        const Component = initializers[index].component;
        return (_jsx(Component, { ...initializedProps[index], children: renderTree(++index) }, void 0));
    };
    return renderTree();
};
export default ParallelContextualizedInitializer;
//# sourceMappingURL=ParallelContextualizedInitializer.js.map